import * as React from "react";
import type { SVGProps } from "react";
const SvgApplynowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="applynow_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M853.333 341.333a42.667 42.667 0 0 1-42.666-42.666v-85.334A42.667 42.667 0 0 0 768 170.667H256a42.667 42.667 0 0 0-42.667 42.666v597.334A42.667 42.667 0 0 0 256 853.333h85.333a42.667 42.667 0 1 1 0 85.334H256a128 128 0 0 1-128-128V213.333a128 128 0 0 1 128-128h512a128 128 0 0 1 128 128v85.334a42.667 42.667 0 0 1-42.667 42.666zM341.333 512a42.667 42.667 0 1 0 0 85.333h128a42.667 42.667 0 1 0 0-85.333h-128zm0-213.333a42.667 42.667 0 0 0 0 85.333h256a42.667 42.667 0 1 0 0-85.333h-256zM660.352 820.18l-66.133 17.366 17.365-66.134c2.688-10.282 8.107-19.669 15.573-27.178l230.528-230.528a42.667 42.667 0 0 1 60.374 60.33L687.488 804.565a59.99 59.99 0 0 1-27.136 15.616zM544.128 938.923l137.899-36.267a145.28 145.28 0 0 0 65.834-37.76L978.39 634.368a128 128 0 1 0-181.034-180.992L566.827 683.904a145.28 145.28 0 0 0-37.76 65.792L492.8 887.595a42.027 42.027 0 0 0 51.328 51.328z"
    />
  </svg>
);
export default SvgApplynowIcon;
